// extracted by mini-css-extract-plugin
export default {"scrollMargin":"CmsHeading-module__scrollMargin-kK3MnI"};